export enum StepKind {
  InternalUser = 'INTERNAL_USER',   // a specific authenticated user
  ExternalParticipant = 'EXTERNAL', // tokenized external participant (email link)
  QueueReview = 'QUEUE_REVIEW',     // office-like queue step (approve/reject)
}

export enum StepStatus {
  Pending = 'pending',     // exists but not active yet
  Active = 'active',       // currently assigned / waiting on actor
  Completed = 'completed', // successfully done
  Rejected = 'rejected',   // rejected (only meaningful for QueueReview or explicit reject steps)
  Skipped = 'skipped',     // (future) optional
  Expired = 'expired',     // (optional) step-level view; request-level Expired is source of truth
  Cancelled = 'cancelled', // (optional) step-level view; request-level Cancelled is source of truth
}

export enum DeliveryChannel {
  None = 'none',   // internal step (no email)
  Email = 'email', // external link delivery
  Sms = 'sms',
}

export enum QueueReviewDecision {
  Approved = 'approved',
  Rejected = 'rejected',
  Acknowledged = 'acknowledged', // ReviewMode.Acknowledge — one click, no reject path
  Filed = 'filed',               // ReviewMode.AutoFile — completed automatically, no human action
}

/**
 * What a QueueReview step actually requires from the office/queue team.
 * Not every terminal queue step is a real decision — e.g. a signed-and-executed
 * document just needs shared queue access + a log entry, not an approval.
 */
export enum ReviewMode {
  Decision = 'DECISION',       // must record Approved or Rejected (default/legacy behavior)
  Acknowledge = 'ACKNOWLEDGE', // one click, single outcome (Acknowledged), no reject path
  AutoFile = 'AUTO_FILE',      // zero-click — completes automatically the instant it activates
}
